import Card from './Card';

export default Card;


//////////////////
// WEBPACK FOOTER
// ./~/element-react/dist/npm/es6/src/card/index.js
// module id = 342
// module chunks = 0